//import React from "react"
//const My = ({ pageContext }) => {
//  return <div>Ciao</div>
//}
//export default Page

import React from "react"
// import { Link } from "gatsby"
//import Layout from "../../components/layout"
// import SEO from "../components/seo"
import {default as SeoComponent} from "../components/seo"
// import PostHeaderMeta from "../components/post-header-meta"
// import PostFooterMeta from "../components/post-footer-meta"
//import AniLink from "gatsby-plugin-transition-link/AniLink"
import { toast } from 'react-toastify';
// import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import { navigate } from "gatsby";
import { window } from 'browser-monads';
// import { document } from 'browser-monads';
import SharePanel from "../components/share"
import FontSizeButton from "../components/font-size"

// const { localStorage } = window;

var time_to_close=10000;
// var myTimer;
// var navigate_to_next_article = true;
// var toastId;
var position;
// var alertArticleDisplayed = false;
// var start = false;
// var middle = false;
// var end = false;

if (window.innerWidth>=500) {
  position = toast.POSITION.TOP_RIGHT;
} else {
  position = toast.POSITION.BOTTOM_CENTER;

}

toast.configure({
  autoClose: time_to_close,
  position: position,
  //draggable: false,
  //etc you get the idea
});

const Option = props => {
  const {
    pageContext: {
      id,
      postId,
      // title,
      // excerpt,
      // content,
      // uri,
      // featuredImage,
      // link,
      // date,
      // author,
      // categories,
      // tags,
      // prev,
      // next,
      // terms,
      vertical,
    },
  } = props

  // var set_vertical_ok = false;

  return (
    <div className="newmag-single-article" vertical={vertical}>
      <SeoComponent title={"Impostazioni"} description={""} />
      <div
        className="newmag_option"
        style={{
          background: "linear-gradient(53.35deg, #EE3D49 0%, #CB356B 100%)",
          marginLeft: "-4.7%",
          height: "310px",
          width: "110%",
        }}
      >
        <div
          className="newmag_option_title"
          style={{
            color: "white",
            height: "135px",
            width: "557px",
            fontFamily: "aktiv-grotesk",
            fontSize: "108px",
            letterSpacing: "2.4px",
            lineHeight: "139px",
            fontWeight: "800",
            paddingLeft: "145px",
            paddingTop: "59px",
          }}
        >
          Impostazioni
        </div>
      </div>
      <article
        data-id={id}
        id={`post-${postId}`}
        className={`newmag-article post-${postId} post type-post status-publish format-standard hentry category-react tag-accessibility tag-gatsby entry`}
        style={{ height: "fit-content" }}
      >
        <div style={{ display: "none" }}>
          {" "}
          <p style={{ margin: "20px", fontSize: "20px" }}>
            {" "}
            Imposta la grandezza dei caratteri degli articoli e se preferisci
            imposta il colore di sfondo con il tema darkmode o lightmode.
          </p>{" "}
        </div>
        <div
          style={{
            display: "none",
            margin: "20px",
            float: "flex",
            width: "100%",
            height: "180px",
          }}
        >
          <SharePanel showonly_option="1" components_name_md5="option" />
        </div>
        <div style={{ padding: "3rem", marginBottom: "6rem" }}>
          <div style={{ display: "inline-block" }}>
            Clicca sul pulsante e scegli la grandezza del testo dell'articolo:
          </div>
          <div className="option-font-size-button" style={{ display: "inline-block", marginLeft: "1.5rem" }}>
            <FontSizeButton />
          </div>
        </div>
        <div
          className="newmag_option_div_esempio"
          style={{ marginTop: "100px", margin: "20px" }}
        >
          <p style={{ fontSize: "20px", marginTop: "180px"  }}>
            <b>Testo di esempio:</b>
          </p>
        </div>
        <div style={{ margin: "20px" }}>
          <p className="entry-content">
            Grandezza del testo dell'articolo. Esempio di testo dell'articolo
            per impostare la grandezza del carattere degli articoli.
          </p>
        </div>
        {/*Object.keys(items).map((obj, k) => {

          if (obj.indexOf("_prefered") !=-1) {
          return <div style={{display: "flex"}}><a href={obj.replace("_prefered","")}><div>- {obj}</div></a><button onClick={()=>removePrefered(obj)}>X</button></div>
        } else {
          return "";
        }


        })
        */}
      </article>
    </div>
  )
}

export default Option
